import './wallet-list';
import 'flickity/css/flickity.css';

import PropTypes from 'prop-types';
import React from 'react';
import Flickity from 'react-flickity-component';

const WalletListCarousel = ({ children, ...props }) => {
  const flickityOptions = {
    initialIndex: 0,
    pauseAutoPlayOnHover: true,
    prevNextButtons: false,
    percentPosition: true,
    cellAlign: 'left',
    contain: true,
    groupCells: true,
    imagesLoaded: false
  };
  return (
    <Flickity
      key={children.length}
      className="carousel"
      elementType="div"
      options={flickityOptions}
      {...props}>
      {children}
    </Flickity>
  );
};

WalletListCarousel.propTypes = {
  children: PropTypes.node
};

export { WalletListCarousel };
